<ph-facts [heading]="section.label || ''">
    <ph-fact *ngFor="let item of section.items; trackBy: trackByIndex">
        <ph-label>{{ item.label }}</ph-label>
        <div>{{ item.value }}</div>
    </ph-fact>
</ph-facts>
